export default __webpack_public_path__ + "static/media/menu.649d4d59.svg";